import type { SchemaInput } from '../shared/schema-input.js';
import { productAccessFromUser, type ProductAccess } from '../shared/plans.js';

let access: ProductAccess | null = null;

export function updateBrowserProductAccess(payload: SchemaInput): void {
  access = productAccessFromUser(payload);
  if ('document' in globalThis && document.documentElement) {
    document.documentElement.dataset.proAccess = String(browserHasProAccess());
  }
}

export function browserHasProAccess(): boolean {
  return access?.pro === true;
}
